<template>
  <div class="Podcasts grid">
    <h1>{{ text }}</h1>
    <div class="grid-auto-md">
      <AboutThumb v-for="podcast in page.podcasts" :item="podcast" :key="podcast.url"></AboutThumb>
    </div>
  </div>
</template>

<script>
import widont from 'widont'
import { mixin } from '@/lib/content-state'

import AboutThumb from '@/components/AboutThumb'

export default {
  name: 'Podcasts',
  mixins: [ mixin ],
  components: { AboutThumb },
  computed: {
    text () {
      return widont(this.page.content)
    }
  }
}
</script>

<style scoped>
h1 {
  grid-column: 1 / -1;
  font: var(--large);
  text-align: center;
  margin: 2rem auto 3rem;
  max-width: 80rem;
}

h1 + .AboutThumb {
  grid-column: 1 / span 3;
}
</style>